import src from "IMAGE";
export default { src, width: 540, height: 540, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAO0lEQVR42q3OsQkAIAxE0YCChYgz6BAuZOcITp9fpEy6BF6V4ziR7JvY0bPh4qF4gWGBjx61LBzUvNUKKGUCWSRejSQAAAAASUVORK5CYII="};
